import { categories } from "@/mocks/home";

function Categories() {
  return (
    <section id="category" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-apps-2-line"></i>
            主题分类
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            海量漫画，随心所选
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从热血到日常，从悬疑到恋爱，每一类漫画都支持翻页音效与翻页动画，
            找到你爱的题材，打开一页纸感阅读。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#comics"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-medium text-foreground-950">{c.name}</span>
                <span className="mt-0.5 block truncate text-xs text-foreground-600">{c.desc}</span>
                <span className="mt-1 block text-xs font-medium text-primary-600">{c.count}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;